import { render, staticRenderFns } from "./MailTemplateListPage.vue?vue&type=template&id=2e1a332c&"
import script from "./MailTemplateListPage.vue?vue&type=script&lang=js&"
export * from "./MailTemplateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports